import React from 'react';
import PackageDetailsPopup from './PackageDetailsPopup';

const CheckPopup = ({ 
  show,
  onClose, 
  orderData = null,
  onConfirm,
  onReport,
  onShowDetails
}) => {
  const handleConfirmAndProceed = () => {
    try {      
      // Call the original onConfirm (manifest download logic)
      if (onConfirm && typeof onConfirm === 'function') {
        onConfirm();
      }
      
      // Close the modal
      if (onClose && typeof onClose === 'function') {
        onClose();
      }
    } catch (error) {
      alert('⚠️ Error confirming package. Please try again.');
    }
  };

  return (
    <PackageDetailsPopup
      show={show}
      onClose={onClose}
      orderData={orderData}
      onConfirm={handleConfirmAndProceed}
      onReport={onReport}
      onShowDetails={onShowDetails}
    />
  );
};

export default CheckPopup;